import { Extension } from '@mui/icons-material';
import { Avatar, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { FC } from 'react';
import { useRecordContext } from 'react-admin';

export const AppOptionRenderer: FC = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <ListItem disablePadding>
      <ListItemAvatar>
        <Avatar src={record.icon?.src} variant="square">
          <Extension />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={record.translated_name} secondary={record.name} />
    </ListItem>
  );
};
